import { createSelector } from "reselect";
import { initialState } from "./reducer";

const layoutState = (state) => state.Layout || initialState;

const makeLayoutSelectField = (field) =>
  createSelector(layoutState, (loginState) => loginState[field]);

export { layoutState, makeLayoutSelectField };
